import { CalendarPickerView } from "@mui/x-date-pickers-pro";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment";
import "moment/locale/th";

/** class CustomAdapter */
export class CustomAdapter extends AdapterMoment {
  constructor({ locale, formats, instance }) {
    super({ locale, formats, instance });
  }

  calYear(moment) {
    switch (this.locale) {
      case "th":
        return (parseInt(moment.format("YYYY")) + 543).toString();
      case "en":
        return parseInt(moment.format("YYYY"));
      default:
        return parseInt(moment.format("YYYY"));
    }
  }

  renderLabel(moment, format) {
    switch (format) {
      case "year":
        return this.calYear(moment);
      case "month":
        return moment.format("MMMM");
      case "fullDate":
        return moment.format("DDMMYYYY");
      case "dayOfMonth":
        return moment.format("D");
      case "monthShort":
        return moment.format("MMMM");
      case "monthAndYear":
        return `${moment.format("MMMM ")} ${this.calYear(moment)}`;
      case "normalDate":
        return `${moment.format("dd")} ${moment.format("MMM")} ${moment.format(
          "D"
        )}`;
      default:
        return moment.format(format);
    }
  }
  
  startOfMonth = (date) => date ? date.clone().startOf("month") : moment(new Date());

  format = (date, formatKey) => {
    return date ? this.renderLabel(date, formatKey) : moment(new Date());
  };
}

export const arrOptionEN = [
  {
    value: 1,
    label: "Quater 1",
  },
  {
    value: 2,
    label: "Quater 2",
  },
  {
    value: 3,
    label: "Quater 3",
  },
  {
    value: 4,
    label: "Quater 4",
  },
];

export const arrOptionTH = [
  {
    value: 1,
    label: "ไตรมาส 1",
  },
  {
    value: 2,
    label: "ไตรมาส 2",
  },
  {
    value: 3,
    label: "ไตรมาส 3",
  },
  {
    value: 4,
    label: "ไตรมาส 4",
  },
];

export const localeMap = (language) => {
  switch (language) {
    case "th":
      moment.locale("th");
      break;
    case "en":
      moment.locale("en");
      break;
    default:
      break;
  }
};

export const dayOfWeekFormatterTH = (day) => {
  return day.charAt(0).toUpperCase() === "เ" ? "ส" : day.charAt(0).toUpperCase()
}

export const ReplaceThFormat = (text) => {
  return text
    ? text
      .toLowerCase()
      .replaceAll("d", "ว")
      .replaceAll("m", "ด")
      .replaceAll("y", "ป")
    : "";
};

export const modeOpenView =(IsMonthYearPicker,IsMonthPicker,IsYearPicker,propsView)=>{
  let strFormat = ["year", "month", "day"];
    if (IsMonthYearPicker) {
      strFormat = ["month", "year"];
    }
    else if (IsMonthPicker) {
      strFormat = ["month"];
    }
    else if (IsYearPicker) {
      strFormat = ["year"];
    }
    else if (propsView) {
      strFormat = propsView;
    }
    return strFormat as readonly CalendarPickerView[];
}

export const modeFormatDate = (IsMonthYearPicker: boolean, IsMonthPicker: boolean, IsYearPicker: boolean, propsFormat: string) => {
  let strFormat = "DD/MM/YYYY";
  if (IsMonthYearPicker) {
    strFormat = "MMMM YYYY";
  }
  else if (IsMonthPicker) {
    strFormat = "MMMM";
  }
  else if (IsYearPicker) {
    strFormat = "YYYY";
  }
  else if (propsFormat) {
    strFormat = propsFormat;
  }

  return strFormat;
}

export const maskMapFormat =(formatDefault : string)=>{
  return {
    en: formatDefault,
    th: ReplaceThFormat(formatDefault)
  }
}